const getters = {
  sidebar: (state) => state.app.sidebar,
  device: (state) => state.app.device,
  token: (state) => state.user.token,
  // name: (state) => state.user.name,
  name: () => "Админ",
  firstName: (state) => state.user.firstName,
  lastName: (state) => state.user.lastName,
  // mediaUrl: (state) => state.user.mediaUrl,
  mediaUrl: () => process.env.VUE_APP_BASE_API + "/media/",
  // siteUrl: (state) => state.user.siteUrl,
  siteUrl: () => process.env.VUE_APP_SITE_URL,
  // roles: (state) => state.user.roles,
  roles: () => ["admin"],
  permission_routes: (state) => state.permission.routes,
  locations: (state) => state.locations.locations,
  pollingToken: (state) => state.polling.token,
};
export default getters;
